import { CloseIcon, RepeatIcon, SettingsIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  Grid,
  ListItem,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import apiCarteira from "api/api-carteira";
import {
  bgError,
  bgInfo,
  bgSucess,
  StatusFormat,
} from "components/dynamic-table/row-status";
import { openModalConfirm } from "components/modal-confirm-new";
import { SkeletonLoading } from "components/skeleton-loading";
import { Toast } from "components/toast";
import { useApplicationContext } from "contexts/ApplicationContext";
import { SelectedCustomer } from "pages/carteira";
import { Dispatch, SetStateAction } from "react";
import { useRouter } from "routes/router-control/use-router";
import { PriceButton } from ".";
import { openModalInfo } from "components/modal-info";
import { getErrorMessage } from "utils/util";
import { CardDataProps } from "pages/servicos";
import { PhoneIcon } from "components/vectors/phone-icon";

export function VendeAICard({
  isLoading,
  priceDesc,
  title,
  serviceData,
  selectedCustomer,
  setCardData,
}: {
  isLoading?: boolean;
  title: string;
  priceDesc: string;
  serviceData: Partial<CardDataProps>;
  selectedCustomer: SelectedCustomer;
  setCardData: Dispatch<SetStateAction<Partial<CardDataProps>>>;
}) {
  const { user } = useApplicationContext();
  const router = useRouter();
  const isSelectedLoggedCustomer =
    user.userData.customerId === selectedCustomer.id;
  let statusCode = serviceData.vendeAI?.statusCode;
  const isActive: boolean = ["active", "free_trial"].includes(statusCode!);
  const isShowButtonsConfigIA = isSelectedLoggedCustomer && isActive;

  const submitConfiguracao = () => {
    router.push(`/config-ai-service?partnerId=${selectedCustomer.id}`);
    // const msg = `Olá! Vim do PowerHub e gostaria de configurar minha IA. Meu ID é: ${user.userData.customerId}`;
    // try {
    //   // window.open(`https://wa.me/5517991258331?text=${msg}`, "_blank");
    // } catch (e: any) {}
  };

  const px = "25px";
  const cardData = serviceData?.["vendeAI"];

  // const changeAtivoStatus = () => {
  //   const operation = !isActive ? "ATIVAR" : "DESATIVAR";
  //   const message = `Deseja ${operation} serviço "${title}"?`;

  //   openModalConfirm({
  //     message,
  //     variant: "normal",

  //     onConfirm: async () => {
  //       try {
  //         const { data } = await apiCarteira.put(
  //           `/services/ia-vendeai/${selectedCustomer.id}/ativo`,
  //           { ativo: !isActive }
  //         );

  //         setCardData((prev) => ({
  //           ...prev,
  //           vendeAI: { ativo: data.ativo },
  //         }));

  //         if (!isActive) {
  //           setTimeout(() => {
  //             openModalInfo({
  //               message: (
  //                 <Box>
  //                   Serviço habilitado! Antes de utilizar:
  //                   <br />
  //                   <br />
  //                   <UnorderedList>
  //                     <ListItem>Configure a Inteligência Artificial</ListItem>
  //                     <ListItem>Configure as Tabelas Digitação</ListItem>
  //                     <ListItem>Configure os Usuários Bancos</ListItem>
  //                   </UnorderedList>
  //                 </Box>
  //               ),
  //               modalProps: { size: "sm" },
  //             });
  //           }, 400);
  //         }
  //       } catch (error: any) {
  //         const errorMessage = error?.response?.data?.message;
  //         Toast({
  //           title: `Não foi possível ${operation.toLocaleLowerCase()} o serviço`,
  //           description: getErrorMessage({
  //             error,
  //             defaultMessage: errorMessage ?? "erro desconhecido",
  //           }),
  //           duration: 6000,
  //           status: "error",
  //         });
  //       } finally {
  //       }
  //     },
  //   });
  // };

  const titleContainerHeight = "80px";

  // https://wa.me/5517991258331

  const statusCodeData = new Map([
    [
      "does_not_exist",
      {
        url: serviceData.vendeAI?.detailsManageSubscriptionLink,
        desc: "Ativar",
        status: "Inativo",
        color: bgError,
      },
    ],
    [
      "pending_activation",
      {
        url: serviceData.vendeAI?.detailsOnboardingLink,
        desc: "Marcar Onboarding",
        status: "Pendente de ativação",
        color: bgError,
      },
    ],
    [
      "free_trial",
      {
        url: serviceData.vendeAI?.detailsManageSubscriptionLink,
        desc: "Gerenciar Assinatura",
        status: "Trial Gratuito",
        color: bgInfo,
      },
    ],
    [
      "active",
      {
        url: serviceData.vendeAI?.detailsManageSubscriptionLink,
        desc: "Gerenciar Assinatura",
        status: "Ativo",
        color: bgSucess,
      },
    ],
    [
      "inactive",
      {
        url: serviceData.vendeAI?.detailsManageSubscriptionLink,
        desc: "Gerenciar Assinatura",
        status: "Inativo",
        color: bgError,
      },
    ],
    [
      "cancelled",
      {
        url: serviceData.vendeAI?.detailsManageSubscriptionLink,
        desc: "Gerenciar Assinatura",
        status: "Cancelado",
        color: bgError,
      },
    ],
  ]);

  return (
    <SkeletonLoading
      isLoading={!!isLoading}
      borderRadius="5px"
      bg="#fff"
      overflow="hidden"
    >
      <Flex
        justifyContent="space-between"
        flexDir="column"
        bg="#fff"
        borderRadius="5px"
        overflow="hidden"
        h="100%"
        border="1px solid var(--chakra-colors-custom-gray)"
      >
        <Flex
          px={px}
          w="100%"
          h={titleContainerHeight}
          // bg="linear-gradient(to right, #141B3B, #B21F17)"
          alignItems="center"
          pos="relative"
          overflow="hidden"
          justifyContent="flex-start"
        >
          <Text
            fontSize={{ base: "18px", "2xl": "20px" }}
            // color="#fff"
            fontWeight="semibold"
          >
            {title}
          </Text>
        </Flex>
        <Flex flexDir="column" px={px} py="15px" minH="215px">
          <Grid
            templateColumns="70px auto"
            gap="10px"
            alignItems="center"
            w="100%"
            mb="10px"
          >
            <Text fontWeight="semibold">Status:</Text>
            <Grid gap="10px">
              <StatusFormat
                w="100%"
                // w="82px"
                bg={statusCodeData.get(statusCode ?? "")?.color}
              >
                {statusCodeData.get(statusCode ?? "")?.status}
              </StatusFormat>
              {statusCodeData.get(statusCode ?? "")?.desc ? (
                <Button
                  // w="calc(100% - 92px)"
                  leftIcon={<RepeatIcon w="13px" h="13px" />}
                  variant={"outline"}
                  size="xs"
                  // onClick={changeAtivoStatus}
                  as="a"
                  target="_blank"
                  href={statusCodeData.get(statusCode ?? "")?.url}
                >
                  {statusCodeData.get(statusCode ?? "")?.desc}
                </Button>
              ) : null}
            </Grid>
          </Grid>{" "}
          <Box w="100%" mt="10px">
            {isShowButtonsConfigIA ? (
              <>
                <Button
                  mt="10px"
                  mb="8px"
                  w="100%"
                  size="sm"
                  variant="outline"
                  bg="#fff"
                  leftIcon={<SettingsIcon />}
                  onClick={submitConfiguracao}
                >
                  Configurar Inteligência Artificial
                </Button>

                <Button
                  as="a"
                  href="/tabelas"
                  target="_blank"
                  mb="8px"
                  w="100%"
                  size="sm"
                  variant="outline"
                  bg="#fff"
                  leftIcon={<SettingsIcon />}
                  // onClick={submitConfiguracao}
                >
                  Configurar Tabelas Digitação
                </Button>
                <Button
                  as="a"
                  href="/usuarios-bancos"
                  target="_blank"
                  mb="8px"
                  w="100%"
                  size="sm"
                  variant="outline"
                  bg="#fff"
                  leftIcon={<SettingsIcon />}
                  // onClick={submitConfiguracao}
                >
                  Configurar Usuários Bancos
                </Button>
                <Button
                  as="a"
                  href="https://wa.me/5517991258331"
                  target="_blank"
                  mb="10px"
                  w="100%"
                  size="sm"
                  variant="outline"
                  bg="#fff"
                  leftIcon={<SettingsIcon />}
                  // onClick={submitConfiguracao}
                >
                  Configurar WhatsApp Oficial
                </Button>
              </>
            ) : null}
            <Button
              as="a"
              href="https://wa.me/5517991258331"
              target="_blank"
              mb="10px"
              w="100%"
              size="sm"
              variant="outline"
              bg="#fff"
              leftIcon={<PhoneIcon width="16px" height="16px" />}
              // onClick={submitConfiguracao}
            >
              Falar com o Suporte Vende AI
            </Button>
          </Box>
        </Flex>
        <Box px={px} pb="15px" mt="auto">
          <PriceButton>{priceDesc}</PriceButton>
        </Box>
      </Flex>
    </SkeletonLoading>
  );
}
